import { convertObjectToSingleString } from '../../../../../utils/helper';
import { LAYOUT_SECTION } from '../../../utils/editorStyles.constants';
export const layoutSection = _ref => {
  let {
    hasInlineStyles
  } = _ref;
  return {
    content: 'layoutColumn{2,3}',
    isolating: true,
    group: 'block',
    parseDOM: [{
      context: 'layoutSection//|layoutColumn//',
      tag: 'div[data-layout-section]',
      skip: true
    }, {
      tag: 'div[data-layout-section]'
    }],
    toDOM() {
      let attrs = {};
      if (hasInlineStyles) {
        attrs = {
          'data-layout-section': 'true',
          class: 'tap-layout-section',
          style: convertObjectToSingleString(LAYOUT_SECTION)
        };
      } else {
        attrs = {
          'data-layout-section': 'true',
          class: 'tap-layout-section'
        };
      }
      return ['div', attrs, 0];
    }
  };
};